<template>
  <div class="newReview" v-if="loginTip">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleCloseNewReview"
      :close-on-click-modal="false"
      :append-to-body="false"
    >
      <p class="title pl14">
        <i class="iconfont icon-ziyuan mr8"></i>
        提示
      </p>
      <div class="content" style="padding: 18px 70px 67px 70px">
        <p style="margin: 20px auto" class="redTip">{{ loginTip }}</p>
        <a class="startReview wid100 hlh56 tac bdr3" @click="handleLogin()">登录</a>
        <div class="tips pt15 pb19 tac lh24 mt16">
          <p style="text-align: left">
            <i class="iconfont icon-ziyuan mr8 fwb"></i>

            注意：若无本系统账号,请联系负责人员开通试用。订购联系人:梁先生 13691470902,服务邮箱:liangyb@cnki.net
            订购电话:010-62701673;010-62791832

          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      loginTip: (state) => state.loginTip,
    }),
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
  methods: {
    handleCloseNewReview() {
      this.$store.dispatch("setLoginTip", null);
    },
    handleLogin() {
      this.handleCloseNewReview();
      this.$router.push("/login");
    },
  },
};
</script>
<style lang="scss" scope>
@import "~@/assets/css/dialog.scss"; //弹窗样式
.redTip {
  font-size: 20px;
  text-align: center;
  color: red;
}
</style>
